<template>
  <div class="firstLoading">
    <p style="text-align: center;"><span style="font-family: 宋体;">推广服务协议</span></p>
    <p><span style="font-family: 宋体;"> </span></p>
    <p><span style="font-family: 宋体;">甲方： </span></p>
    <p><span style="font-family: 宋体;">地址： </span></p>
    <p><span style="font-family: 宋体;">法定代表人： </span></p>
    <p><span style="font-family: 宋体;">联系人：</span></p>
    <p><span style="font-family: 宋体;">联系电话：</span></p>
    <p><br></p>
    <p><br></p>
    <p><span style="font-family: 宋体;">乙方：{{bMerchant.merchantName}}</span></p>
    <p><span style="font-family: 宋体;">地址：{{bMerchant.contactAddress}}</span></p>
    <p><span style="font-family: 宋体;">法定代表人：{{bMerchant.legalName}}</span></p>
    <p><span style="font-family: 宋体;">联系人：{{bMerchant.contactName}}</span></p>
    <p><span style="font-family: 宋体;">联系电话：{{bMerchant.contactMobile}}</span></p>
    <p style="text-align: left;"><span style="font-family: 宋体;"> </span></p>
    <p style="text-indent: 21pt; text-align: left;"><span style="font-family: 宋体;">根据《中华人民共和国民法典》的规定，甲、乙双方本着平等、自愿、诚实信用的原则，经充分协商，甲方同意委托乙方安排</span><u><strong>服务商（定义：为甲方提供商品推广服务的人员）</strong></u><span
      style="font-family: 宋体;">为其商品推广项目提供业务流程外包服务。甲方将商品推广的整个项目外包给乙方。</span></p>
    <p style="text-indent: 21pt; text-align: left;"><span style="font-family: 宋体;"> </span></p>
    <p style="text-indent: 18pt; text-align: left;"><u><strong>【提示条款】</strong></u></p>
    <p style="text-indent: 18pt; text-align: left;"><u><strong>为维护甲、乙双方的自身权益，在甲方点击“确认签约”之前，请认真阅读本协议，务必审慎阅读、充分理解各条款内容，特别是权利义务条款、协议生效条款、法律适用和管辖条款。上述条款以粗体及下划线标识，甲方应重点阅读</strong></u><span
      style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); font-family: 微软雅黑;">。</span></p>
    <p style="text-indent: 18pt; text-align: left;"><span
      style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); font-family: 微软雅黑;"> </span></p>
    <p style="text-indent: 18pt; text-align: left;"><span
      style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); font-family: 微软雅黑;"> </span></p>
    <p style="text-indent: 18pt; text-align: left;"><strong>【签约】</strong><u><strong>当甲方按照提示填写企业认证信息、阅读并同意本协议且点击“确认签约”后，即表示甲方已充分阅读、理解并接受本协议的全部内容，此后甲方不得以未阅读/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果甲方不同意本协议或其中任何条款约定，请甲方立即停止任何的签署程序。</strong></u>
    </p>
    <p style="text-indent: 18pt; text-align: left;"><span
      style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); font-family: 微软雅黑;"> </span></p>
    <p style="text-align: left;"><br></p>
    <p><strong>协议条款：</strong></p>
    <h1><span style="font-family: 宋体;">1 </span><strong>定义</strong></h1>
    <p><span style="font-family: 宋体;">1.1 服务：根据双方签署生效的本协议和具体项目的交易文件，由乙方委托服务商按照甲方的要求，为甲方微商城的商品提供推广服务工作。</span></p>
    <p><span style="font-family: 宋体;">1.2 用户：甲方委托乙方安排服务商直接提供服务的对象。</span></p>
    <p><span
      style="font-family: 宋体;">1.3 交易文件：就商品推广项目甲方委托乙方安排服务商提供的服务，乙方将甲方入驻的第三方平台（以下统称有赞系统）记录的验收标准、结算标准、订单数据认定为交易文件。</span>
    </p>
    <p><span style="font-family: 宋体;">1.4 服务成果：是指乙方按照本协议和交易文件约定所完成的项目工作成果，包括项目文档（包括但不限于服务有关的文件、报告、图表等文字资料），各种数据、参数、技术诀窍以及乙方为履行其义务所搜集、使用、编制、创作的所有其他文档。</span>
    </p>
    <p><span style="font-family: 宋体;">1.5 交付：是指乙方将服务成果提交给甲方。</span></p>
    <p><span style="font-family: 宋体;">1.6 服务验收：是指甲方按照本协议和交易文件约定的标准对乙方的服务成果进行验证的过程。</span></p>
    <p><span style="font-family: 宋体;">1.7 知识产权：指受中国法律及国际公约保护的专利权、商标权、著作权、商业秘密等及其他与之相关的权利。</span></p>
    <p><span style="font-family: 宋体;">1.8 不可抗力：指地震、台风、火灾、水灾、战争、罢工以及其他双方不能预见、不能避免并不能克服的客观情况。</span></p>
    <p><span style="font-family: 宋体;">1.9 工作日：指周一到周五，中国法律、行政法规规定的节假日除外。</span></p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">2 </span><strong>服务内容</strong></h1>
    <p style="text-align: left;"><span
      style="font-family: 宋体;">2.1 </span><u><strong>商品推广的内容及工作量，由双方通过订单来确定。</strong></u><span style="font-family: 宋体;">乙方应依据项目要求的专业服务能力，在指定期限内组织服务商提供服务，并通过日常管理保证达到交易文件要求的目标，按时提交服务成果，并及时告知甲方服务进度以及相关的服务信息。</span>
    </p>
    <p><span style="font-family: 宋体;">2.2 根据甲方主营业务，乙方为甲方或甲方运营服务的业务平台或客户提供服务，服务范围所属下列情况和人员类别：</span></p>
    <p style="text-indent: 20.75pt;"><span style="font-family: 宋体;">电子商务网店个人工作者；</span></p>
    <p style="text-indent: 20.75pt;"><span style="font-family: 宋体;">自媒体平台个人工作者或互联网媒体平台个人工作者；</span></p>
    <p style="text-indent: 20.75pt;"><span style="font-family: 宋体;">共享经济平台个人工作者；</span></p>
    <p style="text-indent: 20.75pt;"><span style="font-family: 宋体;">直播平台网红主播；</span></p>
    <p style="text-indent: 20.75pt;"><span style="font-family: 宋体;">物流众包配送平台自主雇佣骑手；</span></p>
    <p style="text-indent: 20.75pt;"><span style="font-family: 宋体;">互联网平台业务承接人；</span></p>
    <p style="text-indent: 20.75pt;"><span style="font-family: 宋体;">其他众包平台业务承接人；</span></p>
    <p style="text-align: left;"><span style="font-family: 宋体;">乙方负责完成上述服务范围内的项目分包，并为项目承接人完成报酬发放、个人所得税核定申报等工作。</span>
    </p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">3 </span><strong>服务订单的签署流程</strong></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 宋体;">甲方根据商品推广的实际需求向乙方提出服务申请。</span></p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">4 </span><strong>交付及验收</strong></h1>
    <p><u><strong>服务商帮甲方进行商品推广，消费者通过服务商推荐的链接购买并确认收货后，则服务商的推广服务完成，同时默认乙方工作的交付已经完成，甲方验收合格。</strong></u></p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">5 </span><strong>推广服务费及支付</strong></h1>
    <p><span style="font-family: 宋体;">5.1 推广服务费</span></p>
    <p><u><strong>乙方推广服务费的计费基础比例为【6.9%】（含个税），按以下两种方式收取皆可，实际以甲方在有赞商城后台的配置选项为准。</strong></u></p>
    <p><u><strong>（1）由服务商承担，则乙方收取的推广服务费为：甲方在有赞系统中的订单金额*甲方在有赞系统后台设置的佣金比例。（乙方将扣除有赞系统中的订单金额*甲方在有赞系统后台设置的佣金比例*计费基础比例之后支付给服务商）；</strong></u>
    </p>
    <p><u><strong>（2）由甲方承担，则乙方收取的推广服务费为：甲方在有赞系统中的订单金额*甲方在有赞系统后台设置的佣金比例*（1+计费基础比例）。（乙方将甲方在有赞系统中的订单金额*甲方在有赞系统后台设置的佣金比例支付给服务商）；</strong></u>
    </p>
    <p><span style="font-family: 宋体;">5.2 支付</span></p>
    <p><span style="font-family: 宋体;">1） 甲方根据乙方的服务成果通过有赞后台的资金账户向乙方进行服务费用结算支付。</span></p>
    <p><span
      style="font-family: 宋体;">2） 在乙方确认收到甲方支付的相关款项后，按照税务机关的相关意见和要求，向甲方开具符合国家规定的6%增值税发票（乙方开票内容根据税务机关的要求办理均可）。</span></p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">6 </span><strong>权利和义务</strong></h1>
    <p><span style="font-family: 宋体;">6.1 甲方权利和义务</span></p>
    <p><span
      style="font-family: 宋体;">1） </span><u><strong>甲方向乙方提出商品推广的具体需求，乙方应按甲方需求及本协议约定及时提交服务计划并组织服务商完成服务。</strong></u></p>
    <p><span style="font-family: 宋体;">2） </span><u><strong>甲方应向乙方提供并允许乙方为服务工作目的而使用合同双方商议确认的信息、数据、资料。</strong></u></p>
    <p><span style="font-family: 宋体;">3） </span><u><strong>如乙方履行本合同过程中需与第三方配合，甲方应负责协调乙方与第三方的工作，并有权知悉乙方与第三方的集体合作方案。甲方如对合作方案有异议，乙方应当按照甲方实际要求进行相应调整。</strong></u>
    </p>
    <p><span style="font-family: 宋体;">6.2 </span><strong>乙方权利和义务</strong></p>
    <p><span style="font-family: 宋体;">1） </span><u><strong>乙方应按照本协议及交易文件的要求，安排服务商如期完成其服务并交付服务成果。</strong></u></p>
    <p><span style="font-family: 宋体;">2） </span><u><strong>乙方保证其安排的服务商拥有为具体项目提供服务的资质及能力，并保证服务成果不侵犯任何第三方的知识产权，同时配合甲方达成最终用户的满意度。</strong></u>
    </p>
    <p><span style="font-family: 宋体;">3） </span><u><strong>乙方保证其安排的服务商的服务符合约定的服务质量要求。</strong></u></p>
    <p><span
      style="font-family: 宋体;">4） </span><u><strong>乙方不得在甲方具体项目未结束的情况下，以任何方式协助已经向甲方提供的服务商调入与甲方有竞争关系的公司工作。</strong></u>
    </p>
    <p><span style="font-family: 宋体;">5） </span><u><strong>如果乙方更换安排的服务商，应当提前 十个工作日通知甲方，并经甲方书面同意，方可更换。</strong></u></p>
    <p><span style="font-family: 宋体;">6） </span><u><strong>乙方应当指定人员具体负责就具体项目所安排的服务商的日常监督与管理。</strong></u></p>
    <p><span
      style="font-family: 宋体;">7） </span><u><strong>在服务商为甲方或甲方用户服务期间，如服务商发生人身或财产损害的，由责任方依法承担相关责任，乙方不承担该项责任。</strong></u>
    </p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">7 </span><strong>知识产权及保密</strong></h1>
    <p><span style="font-family: 宋体;">7.1 若乙方和乙方安排的服务商依照本协议和交易文件向甲方交付的服务成果及提供服务过程中新产生相关知识产权的。该知识产权中的人身权利根据国家相关法律法规确定，该知识产权中的财产权利归甲方或甲方指定的所有。如果甲方或甲方指定的用户与乙方或服务商另行约定的，从其约定。</span>
    </p>
    <p><span style="font-family: 宋体;">7.2 乙方保证在项目服务过程中，不存在侵犯第三方专利权、商标权、著作权等知识产权的行为。如果涉及到使用第三方知识产权的，乙方保证已获得所有权人或其他授权人的合法授权。</span>
    </p>
    <p><span style="font-family: 宋体;">7.3 甲、乙中任何一方对在本协议签订或履行过程中所接触到的对方的未公开的、且已经采取了有效保密措施的商业秘密（包括但不限于：技术资料、技术诀窍、业务经营信息、内部管理方法、内部规章制度、最终客户信息、项目信息以及其他与企业经营相关的信息）负有保密义务。非因基于履行本协议的需要，或者由法律、法规规定，或经有关机构要求或者对方同意，不得向任何第三方透露。</span>
    </p>
    <p><span style="font-family: 宋体;">7.4 本协议终止后，一方将立即归还从对方处获得的一切保密信息，或者以对方认可的方式进行销毁。任何一方因违反保密义务而给另一方造成损失的，应负相应的赔偿责任。保密期限不受本合同期限的限制，在本合同履行完毕后一年内，保密信息接受方仍应承担保密义务。</span>
    </p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">8 </span><strong>违约责任</strong></h1>
    <p><span
      style="font-family: 宋体;">8.1 甲、乙双方任何一方不履行合同义务或者履行合同义务不符合约定的，均视为违约。违约方应当承担继续履行、采取补救措施或者支付违约金、赔偿损失等违约责任。</span></p>
    <p><span style="font-family: 宋体;">8.2 在具体项目服务过程中，在甲、乙双方已经商定和确认相关服务内容事项之后，任何一方提出变更要求，导致服务进度延迟的，不视为对方违约；如果因此而给对方造成损失的，由提出变更一方赔偿对方直接经济损失。</span>
    </p>
    <p><span style="font-family: 宋体;">8.3 因甲方的原因或与甲方具有协作关系的第三方的原因导致乙方或乙方安排的服务商的服务进度延迟的，乙方不承担违约责任；因此而给乙方或乙方安排的服务商增加工作量的，甲方应当按照乙方提出的合理方案给予补偿。</span>
    </p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">9 </span><strong>法律适用及争议解决</strong></h1>
    <p><span style="font-family: 宋体;">9.1 </span><u><strong>本协议的成立、有效性、解释、履行及由此产生的争议的解决，均应适用中华人民共和国法律。</strong></u></p>
    <p><span style="font-family: 宋体;">9.2 因本协议引起的或与本协议有关的任何争议，应本着友好合作的态度协商解决；</span><u><strong>如协商不成，均可向乙方所在地有管辖权的人民法院起诉，通过诉讼方式解决。</strong></u>
    </p>
    <p><span style="font-family: 宋体;">9.3 诉讼期间，除争议内容以外，双方均应继续履行协议约定的其他内容。</span></p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">10 </span><strong>不可抗力</strong></h1>
    <p><span style="font-family: 宋体;">10.1 由于不可抗力致使合同无法履行的，受不可抗力影响一方应及时将不能履行本协议的事实书面通知对方。</span></p>
    <p><span style="font-family: 宋体;">10.2 本协议在不可抗力影响范围及其持续期间内将中止履行，本协议执行时间可根据中止的时间相应顺延，双方无须承担违约责任。</span></p>
    <p><span style="font-family: 宋体;">10.3 在不可抗力事件消除后，甲、乙双方应就协议的履行及后续问题进行协商。如果不可抗力原因造成本协议中止履行超过三十个工作日，任何一方均有权解除合同。且无须承担任何违约责任。对于乙方、乙方安排的服务商已经提供的服务，甲方仍应当支付相应的服务费用。</span>
    </p>
    <p><span style="font-family: 宋体;">10.4 一方迟延履行后发生不可抗力的，不能免除责任。</span></p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">11 </span><strong>协议的生效、期限、变更和终止</strong></h1>
    <p><span style="font-family: 宋体;">11.1 </span><u>本协议采用线上签署，甲乙双方通过网络页面完成相应操作，生成双方的电子签章（甲方公章或法定代表人签名、乙方公章）后即表示甲乙双方已达成本协议，本协议的生效时间以电子合同系统中显示为准。</u>
    </p>
    <p><span
      style="font-family: 宋体;">11.2 本协议的有效期为两年。协议到期前一个月，经双方协商一致，可对本协议进行续签。若双方未签署新的协议，而以实际行动继续合作的，视为双方同意本协议期限顺延。</span>
    </p>
    <p><span style="font-family: 宋体;">11.3 在本协议履行过程中，经甲、乙双方协商一致可另行签订补充协议，可以变更或解除本协议。</span></p>
    <p><span style="font-family: 宋体;">11.4 本协议未尽事宜，经甲、乙双方协商一致可另行签订补充协议，补充协议与本协议具有同等法律效力。</span></p>
    <p><span style="font-family: 宋体;">11.5 本协议、本协议向下的交易文件、相关附件任何条款之法律效力于尚未终止前，均及于甲、乙双方以及各自的承继人、受让人、继受人、受托人。</span></p>
    <p><span style="font-family: 宋体;">11.6 本协议无效或者提前解除的，对于尚未履行的部分，甲、乙双方不再履行；对于甲方已支付费用但乙方、乙方安排的服务商尚未开始或尚未完成的工作，乙方应按照尚未开始或尚未完成部分占甲方已支付费用而应当完成的全部工作的比例，退还甲方已支付的费用；对于乙方已完工但甲方还未支付费用的工作，甲方应当按此部分工作量占整体工作量的比例，向乙方支付上述终止之时乙方已提供的服务的费用。</span>
    </p>
    <h1 style="text-align: justify;"><span style="font-family: 宋体;">12 </span><strong>附则</strong></h1>
    <p><span style="font-family: 宋体;">12.1 协议结构。具体项目的交易文件及与其他相关的文件（包括但不限于发票、补充文件、计划、附表、服务实施细则、授权变更或附录、邮件等）均为本协议的有效组成部分。当交易文件与本协议有冲突时，以最终签署的交易文件为准。</span>
    </p>
    <p><span style="font-family: 宋体;">12.2 完整协议。本协议构成甲乙双方对本协议所涉事项的完整合同，它取代了此前双方就该等事项作出的任何口头或书面合同或许诺。</span></p>
    <p><span style="font-family: 宋体;">12.3 条款的可分割性。本协议所包含的任何条款在被认为无效或不具有强制执行力的情况下，该条款的无效性或不可执行性不影响其他条款的效力。</span></p>
    <p><span style="font-family: 宋体;">12.4 弃权。本协议的任何条款或表述均不得被视为对一方权利的放弃，任何违约行为亦不得被免除责任，除非享有权利的一方以书面确认该等弃权或免责。任何一方以明示或暗示的方式同意免除或放弃追究另一方在某方面的违约责任，并不意味着免除或放弃追究该另一方在其他方面或后续发生的违约责任。</span>
    </p>
    <p><span style="font-family: 宋体;">12.5 标题。本协议中的标题仅作为参考，不影响本合同的含义及其解释。</span></p>
    <p><span style="font-family: 宋体;">12.6 通知。甲、乙双方因履行本协议而相互发出或者提供的所有、文件、资料，均以本协议所列明的联系人、联系地址、联系电话、邮箱、微信号送达，一方如果迁址或者变更联系人、联系电话、邮箱、联系微信号的，应当事先书面通知对方。通知以专人送出的，由被送达人在送达回执上签名（或盖章），被送达人签收时间为送达时间；通知以邮寄方式送出的，以中国邮政EMS或者其他专业快递公司官网或者短信、微信确认的投妥时间为送达时间；通知以传真的方式送出的，在发出传真时视为送达（如收件方未收到传真或者收到传真不清楚、不完整的，应当及时与发送方联系补发传真）；通知以电子邮件、手机短信、微信号方式送出的，以发送系统自动生成的发送时间为送达时间。</span>
    </p>
    <p><br></p>
    <div style="text-align:center;margin-bottom:20px;">（以下无正文）</div>
      <div class="footer">
      <div class="jia">
        <p>甲方：</p>
        <p>法定代表人或其授权代理人：</p>
        <p>签字：</p>
        <p>日期：</p>
      </div>
      <div>
        <p>乙方：</p>
        <p>法定代表人或其授权代理人：</p>
        <p>签字：</p>
        <p>日期：</p>
      </div>
    </div>

    <p style="margin:5pt 0pt; text-align:center"><span
        style="color:#333333;  font-size:7.5pt; font-weight:bold">本协议由汉唐融科提供</span></p>

  </div>
</template>
<script>
import BusinessDict from "../../utils/businessDict";

export default {
  data(){
    return{
      loading:true,
      rate: "6.9",
      bMerchant: {
        merchantName: "",
        legalName: "",
        contactName: "",
        contactMobile: "",
        contactEmail: "",
        contactAddress: "",
        serviceRate: "*",
      },
    }
  },
  mounted() {
    const url = new URL(location.href);
    let b = url.searchParams.get('b');
    console.log(url, b);
    b = b || "zslhkjyxgs";
    let bMerchant = BusinessDict.BMerchant[b];
    console.log(bMerchant);
    if (bMerchant) {
      this.bMerchant = bMerchant;
    }
    console.log(this.bMerchant);
  },
  methods:{
  }
}
</script>
<style lang="less" scoped>
.firstLoading{
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  text-align: left;
}
.loading-block{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 22px;
  font-size: 12px;
}
body { margin: 0;
  padding: 10px;
}
 .footer{
    display: flex;
    justify-content: space-around;
    padding-bottom:40px ;
  }
  .footer div{
    text-align: left;
  }
  .jia{
    position: relative;
  }
  .date{
    position: absolute;
    bottom: 0;
    left: 0;
  }
  p,div,span{
     font-family:宋体;
  }
</style>



// WEBPACK FOOTER //
// src/pages/agreement/aggreement_yz_merchant.vue